<template>
<div class="bigScreen" id="agentWorkPlace" :style="{'height':screenHeight.height,'background-image':'url(\''+bgImg+'\')'}">
    <!--头部-->
    <div class="header">
        <div style="width: 33%;height: 100%;float: left"></div>
        <div class="logo">
            <div class="logo-img">
                <img :src="logo" alt />
            </div>
            <p class="title-font">{{title}}</p>
        </div>
        <div style="width: 33%;height: 100%;float: left"></div>
        <div class="showTimenext"></div>
        <div>
            <img v-show="!fullscreen" src="../../assets/image/fullScreen.png" @click="btnFull()" style="width: 3vmin;height: 3vmin;float:right;margin-right:2em;margin-top:-0.3rem;" />
            <img v-show="!fullscreen" :src="setButton" @click="setScreen(1)" style="width: 3vmin;height: 3vmin;float:right;margin-right:1em;margin-top:-0.3rem;" />
        </div>
    </div>
    <section class="mainbox">
        <div style="text-align:center;width: 100%;height: 15%;">
            <div class="top_one">
                <div v-for="(item, index) in totalStatusList" :key="index" :class="changTotalClass(item.agentStatus)">
                    <span style="font-size: 0.24rem;color: white;width: 100%;transform: skewX(23deg);">{{item.statusName}}:
                        {{item.statusNum}}</span>
                </div>
            </div>
        </div>
        <div class="top_two">
            <div class="screenTwo" style="height:95%;">
                <el-carousel :interval="5000" arrow="never" height="100%" @change="changeAgent" indicator-position="none">
                    <el-carousel-item v-for="item in agentListSize" :key="item" style="height:100%;width: 100%;">
                        <div style="width: 100%;height: 100%;" :class="changbigClass(gap)">
                            <div v-for="key in 4" :key="key" style="width: 100%;height: 25%;overflow:hidden;">
                                <div v-for="i in 8" :key="i" :class="changClass(agentList[(item-1)*32+(i-1)+((key-1)*8)].agentStatus)" style="text-align: center;" v-if="((item-1)*32+((key-1)*8)+(i-1))<agentList.length">
                                    <div style="width:80%;margin:0 auto;overflow-x: hidden;">
                                        <p style="color: white;font-size: 0.18rem;">{{agentList[(item-1)*32+(i-1)+((key-1)*8)].agentname}}
                                            {{agentList[(item-1)*32+(i-1)+((key-1)*8)].agentnum}}<br>{{agentList[(item-1)*32+(i-1)+((key-1)*8)].statusName}}<br>
                                            {{agentList[(item-1)*32+(i-1)+((key-1)*8)].changeTime}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>

    </section>
    <BigScreenTwoPop :showBigScreenTwo="showBigScreenTwo" :idForShow="idForShow" @closeBigScreenTwo="closeBigScreenTwo">
    </BigScreenTwoPop>
</div>
</template>

<script>
import {
    publicFunClass
} from '@/components/js/PublicFunClass.js'
import BigScreenTwoPop from '@/components/bigScreen/BigScreenTwoPop.vue';
export default {
    name: "AgentWorkplace",
    mixins: [publicFunClass],
    components: {
        BigScreenTwoPop
    },
    data() {
        return {
            title: '座席职场', //大屏标题
            showSize: 1,
            timer: '',
            timeOne: '',
            newListSize: '',
            idForShow: '',
            totalStatusList: [],
            logo: '',
            bgImg: require('../../assets/image/bg.jpg'), //大屏背景
            showBigScreenTwo: false,
            agentListSize: 0,
            agentList: [],
            screenHeight: {
                height: ''
            },
            fullscreen: false,
            setButton: require('../../assets/image/screen_setting.png'),
            queryStatus: [2, 2, 6, -1],
            showStatus: [0, 2, 6, -1],
            autoplay: true,
            dt: null,
            year: null,
            month: null,
            day: null,
            hour: null,
            minute: null,
            seconds: null,
            gap: false,
        }
    },
    methods: {
        closeBigScreenTwo: function (flag) {
            this.showBigScreenTwo = false;
            if (flag) {
                // setTimeout(this.getStatus(),500);
                this.getStatus();
            }
        },
        changTotalClass: function (statusId) {
            if (statusId === '0') { //空闲
                return 'free_icon_free';
            } else if (statusId === '-1') { //离线
                return 'free_icon_offline';
            } else if (statusId == '6') { //忙碌
                return 'free_icon_busy';
            } else if (statusId == '2') { //通话中
                return 'free_icon_call';
            } else if (statusId == '1') { //振铃
                return 'free_icon_ring';
            } else if (statusId == '3') { //保持
                return 'free_icon_hold';
            } else if (statusId == '4') { //后处理
                return 'free_icon_deal';
            } else if (statusId == '5') { //被占用
                return 'free_icon_occupy';
            } else if (statusId == '7') { //离开
                return 'free_icon_leave';
            } else if (statusId == '8') { //仅呼出
                return 'free_icon_only';
            } else { //其他
                return 'free_icon_other';
            }
        },
        changClass: function (statusId) {
            if (statusId === '0') { //空闲
                return 'img_free';
            } else if (statusId === '-1') { //离线
                return 'img_offline';
            } else if (statusId == '6') { //忙碌
                return 'img_busy';
            } else if (statusId == '2') { //通话中
                return 'img_call';
            } else if (statusId == '1') { //振铃
                return 'img_ring';
            } else if (statusId == '3') { //保持
                return 'img_hold';
            } else if (statusId == '4') { //后处理
                return 'img_deal';
            } else if (statusId == '5') { //被占用
                return 'img_occupy';
            } else if (statusId == '7') { //离开
                return 'img_leave';
            } else if (statusId == '8') { //仅呼出
                return 'img_only';
            } else { //其他
                return 'img_other';
            }
        },
        // 获取汇总数据和查询数据
        getStatus: function () {
            let that = this;

            let param = {
                journalType: null,
                menuId: null,
                type: "workPlace"
            };
            this.$http.post("bigScreen/toBigScreenIndex.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }

                // 页面参数
                let configPic = JSON.parse(res.data.obj.configPic);
                if ("" != configPic.workPlace) {
                    that.title = configPic.workPlace;
                }
                if ("" != configPic.logo) {
                    that.logo = that.baseImgURL + configPic.logo;
                }else{
                    that.logo = require('../../assets/image/logo.png');
                }
                if ("" != configPic.bgImg) {
                    that.bgImg = that.baseImgURL + configPic.bgImg;
                }
                // 查询数据
                that.idForShow = res.data.obj.configDesign.id;
                let configDesign = JSON.parse(res.data.obj.configDesign.value);
                that.queryStatus = configDesign.queryStatus;
                that.showStatus = configDesign.showStatus;

                that.getAgent();
            });
        },
        // 设置大屏
        setScreen() {
            this.showBigScreenTwo = true;
        },

        //定时切换页面触发的方法
        changeAgent: function () {
            let that = this;
            let param = {
                journalType: null,
                menuId: null,
                type: "workPlace"
            };
            this.$http.post("bigScreen/toBigScreenIndex.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != "666") {
                    that.$Modal.info({
                        title: '提示',
                        content: res.data.msg
                    });
                    return false;
                }
                // 查询数据
                that.idForShow = res.data.obj.configDesign.id;
                let configDesign = JSON.parse(res.data.obj.configDesign.value);
                that.queryStatus = configDesign.queryStatus;
                that.showStatus = configDesign.showStatus;

                that.showSize = that.showSize + 1;
                if (that.showSize > that.agentListSize) {
                    that.agentList = [];
                    that.showSize = 1;
                }

                that.queryStatus = that.sortStatus(that.queryStatus.split(","));
                that.showStatus = that.sortStatus(that.showStatus.split(","));

                param = {
                    queryStatus: that.queryStatus.toString(),
                    showStatus: that.showStatus.toString(),
                    pageNum: that.showSize,
                    pageSize: '32'
                }

                that.$http.post("bigScreen/toEmpWorkplaceIndex.json", param).then(function (res) {
                    let result = res.data.flag;
                    if (result != '666') {
                        that.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定'
                        });
                        return false;
                    }
                    that.totalStatusList = res.data.obj.totalList;
                    let list = res.data.obj.list.content;
                    that.agentListSize = parseInt(res.data.obj.list.totalPages);
                    if(that.agentListSize && that.timer){
                        clearTimeout(that.timer);
                    }
                    if (list) {

                        if (that.showSize > that.agentListSize) {
                            that.showSize = 1;
                        }

                        if (that.showSize == 1) {
                            that.agentList = list;
                        } else {
                            that.agentList = that.agentList.concat(list);
                        }
                        
                        if (that.agentListSize <= 1) {
                            
                            that.timer = setTimeout(that.getStatus, 5000);
                        }
                    }
                });

            });

        },
        // 处理实时时间
        setTime() {
            let that = this;
            that.dt = new Date();
            that.year = that.dt.getFullYear();
            that.month = that.dt.getMonth() + 1;
            that.day = that.dt.getDate();
            that.hour = that.dt.getHours(); //获取时
            that.minute = that.dt.getMinutes(); //获取分
            that.seconds = that.dt.getSeconds(); //获取秒
            document.querySelector(".showTimenext").innerHTML =
                that.year + "-" + //年
                (that.month < 10 ? ("0" + that.month) : that.month) + "-" + //月
                (that.day < 10 ? ("0" + that.day) : that.day) + //日
                "&nbsp;&nbsp;&nbsp" +
                (that.hour < 10 ? ("0" + that.hour) : that.hour) + ":" + //时

                (that.minute < 10 ? ("0" + that.minute) : that.minute) + ":" + //分

                (that.seconds < 10 ? ("0" + that.seconds) : that.seconds); //秒

        },
        // 全屏事件
        handleFullScreen() {
            let element = document.getElementById("agentWorkPlace"); //放大的元素，如果整个系统放大，直接赋值 document.documentElement
            if (this.fullscreen) {
                this.gap = true;
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                this.gap = false;
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
            this.gap = !this.gap;
        },
        btnFull() {
            this.fullscreen = false;
            this.gap = false;
            this.handleFullScreen();

        },
        changbigClass: function (gap) {
            if (gap == true) {
                return 'gap_two';
            } else {
                return 'gap_one';
            }
        },
        //查询所有座席状态
        getAgent: function () {
            let that = this;
            that.queryStatus = that.sortStatus(that.queryStatus.split(","));
            that.showStatus = that.sortStatus(that.showStatus.split(","));
            let param = {
                queryStatus: that.queryStatus.toString(),
                showStatus: that.showStatus.toString(),
                pageNum: '1',
                pageSize: '32'
            }

            that.$http.post("bigScreen/toEmpWorkplaceIndex.json", param).then(function (res) {
                let result = res.data.flag;
                if (result != '666') {
                    that.$alert(res.data.msg, '提示', {
                        confirmButtonText: '确定'
                    });
                    return false;
                }
                that.totalStatusList = res.data.obj.totalList;
                let list = res.data.obj.list.content;
                that.agentListSize = parseInt(res.data.obj.list.totalPages);
                if(that.agentListSize && that.timer){
                    clearTimeout(that.timer);
                }
                if (list) {
                    that.agentList = list;
                    console.log("agentListSize::"+that.agentListSize);
                    if (that.agentListSize <= 1) {
                        that.timer = setTimeout(that.getStatus, 5000);
                    }
                }
            });
        },

        // 对状态进行排序
        sortStatus(statusList) {
            let newStatusList = new Array(statusList.length).join(',').split(',');
            for (let n = 0; n < statusList.length; n++) {
                if ('0' === statusList[n]) { //空闲
                    newStatusList[0] = '0';
                } else if ('2' === statusList[n]) { //通话中
                    newStatusList[1] = '2';
                } else if ('6' === statusList[n]) { //忙碌
                    newStatusList[2] = '6';
                } else if ('5' === statusList[n]) { //被占用
                    newStatusList[3] = '5';
                } else if ('7' === statusList[n]) { //离开
                    newStatusList[4] = '7';
                } else if ('8' === statusList[n]) { //仅呼出
                    newStatusList[5] = '8';
                } else if ('4' === statusList[n]) { //后处理
                    newStatusList[6] = '4';
                } else if ('3' === statusList[n]) { //保持
                    newStatusList[7] = '3';
                } else if ('1' === statusList[n]) { //振铃
                    newStatusList[8] = '1';
                } else if ('-1' === statusList[n]) { //离线
                    newStatusList[9] = '-1';
                }
            }

            for (let i = 0; i < newStatusList.length; i++) {
                if (newStatusList[i] == undefined || newStatusList[i] == "") {
                    newStatusList.splice(i, 1);
                    i--;
                }
            }
            return newStatusList;
        },

        resizeFun() {
            var firstOnResizeFire = true; //谷歌浏览器onresize事件会执行2次，这里加个标志位控制
            let that = this;
            if (firstOnResizeFire) {

                var isFull = document.isFullScreen || document.mozIsFullScreen || document.webkitIsFullScreen;
                if (isFull === undefined) {
                    isFull = false;
                }
                if (isFull) {
                    that.fullscreen = true;
                    that.$forceUpdate();
                } else {
                    that.fullscreen = false;
                    that.$forceUpdate();
                }

                setTimeout(function () {
                    firstOnResizeFire = true;
                }, 500);
                return isFull;
            }
        },
    },

    created() {
        this.screenHeight.height = this.mountHeight(100);
    },
    mounted() {
        this.setTime();
        this.timeFlag = setInterval(this.setTime, 1000); //开始运行
        this.getStatus();
        window.addEventListener("resize", this.resizeFun);
    },
    beforeDestroy() {
        if (this.timeFlag) {
            clearInterval(this.timeFlag);
        }
        clearTimeout(this.timer);
        window.removeEventListener("resize", this.resizeFun);
        this.resizeFun = null;
        this.closeBigScreenTwo = null;
        this.changTotalClass = null;
        this.changClass = null;
        this.getStatus = null;
        this.setScreen = null;
        this.changeAgent = null;
        this.setTime = null;
        this.handleFullScreen = null;
        this.btnFull = null;
        this.getAgent = null;
        this.sortStatus = null;

    },

}
</script>

<style lang="less" scoped>
@import "../../assets/css/daping.less";

.el-carousel {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/bigScreen/AgentWorkplace.vue